import React, { useEffect, useState } from 'react';
import './Reception.css';
import Graph3 from '../components/Graph3';

const API = window.location.hostname === 'localhost'
  ? 'http://localhost:5000/api'
  : 'https://myssa1.osc-fr1.scalingo.io/api';

const Reception = () => {

    useEffect(() => {
    document.title = 'MYSSA – Réception';
  }, []);

  const [commandeFournisseurData, setCommandeFournisseurData] = useState([]);
  const [emplacementVideData, setEmplacementVideData] = useState([]);
  const [stockData, setStockData] = useState([]);
  const [itemFilter, setItemFilter] = useState('');
  const [numeroCommandeFilter, setNumeroCommandeFilter] = useState('');
  const [fournisseurFilter, setFournisseurFilter] = useState('');

  useEffect(() => {
    fetch(`${API}/base_de_donnee_cmde_frn`)
      .then(response => response.json())
      .then(data => setCommandeFournisseurData(data))
      .catch(error => console.error('Erreur base_de_donnee_cmde_frn:', error));

    fetch(`${API}/emplacement_vide`)
      .then(response => response.json())
      .then(data => setEmplacementVideData(data))
      .catch(error => console.error('Erreur emplacement_vide:', error));

    const fetchStockData = async () => {
      try {
        const response = await fetch(`${API}/base_de_donne_stock`);
        const data = await response.json();
        setStockData(data);
      } catch (error) {
        console.error('Erreur stock:', error);
      }
    };
    fetchStockData();
  }, []);

  const applyCombinedFilter = (data) => {
    return data.filter(item =>
      (!itemFilter || (item['Item'] && item['Item'].toLowerCase().includes(itemFilter.toLowerCase()))) &&
      (!numeroCommandeFilter || (item['Numero de commande'] && item['Numero de commande'].toLowerCase().includes(numeroCommandeFilter.toLowerCase()))) &&
      (!fournisseurFilter || (item['Fournisseur'] && item['Fournisseur'].toLowerCase().includes(fournisseurFilter.toLowerCase())))
    );
  };

  const applyFilter = (data, filter, column) => {
    if (!filter) return data;
    return data.filter(item =>
      item[column] && item[column].toLowerCase().includes(filter.toLowerCase())
    );
  };

  const resetFilters = () => {
    setItemFilter('');
    setNumeroCommandeFilter('');
    setFournisseurFilter('');
  };

  // Badge Horizon
  const renderHorizonBadge = (value) => {
    const styles = {
      base: {
        display: 'inline-block',
        padding: '2px 8px',
        borderRadius: '6px',
        fontFamily: "'IBM Plex Mono', monospace",
        fontSize: '10px',
        fontWeight: '500',
      },
      Retard: { backgroundColor: '#fee2e2', color: '#b91c1c' },
      J:      { backgroundColor: '#fef9c3', color: '#92400e' },
    };
    const s = styles[value] || { backgroundColor: '#dcfce7', color: '#15803d' };
    return <span style={{ ...styles.base, ...s }}>{value}</span>;
  };

  const renderTable = (data, columns) => {
    if (data.length === 0) {
      return (
        <p style={{ padding: '16px', fontFamily: "'IBM Plex Sans', sans-serif", fontSize: '13px', color: '#8b7b64' }}>
          Item pas en stock / pas en commande
        </p>
      );
    }

    return (
      <table className="table4">
        <thead>
          <tr>
            {columns.map((column, index) => (
              <th key={index}>{column}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={index}>
              {columns.map((column, colIndex) => {
                let value = item[column];

                if (column === 'Horizon') {
                  return <td key={colIndex}>{renderHorizonBadge(value)}</td>;
                }

                if (column === 'Date de livraison' && value) {
                  const dateObj = new Date(value);
                  if (!isNaN(dateObj)) {
                    const day = String(dateObj.getDate()).padStart(2, '0');
                    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
                    const year = dateObj.getFullYear();
                    value = `${day}/${month}/${year}`;
                  }
                }

                return <td key={colIndex}>{value}</td>;
              })}
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  return (
    <div className="reception-container">

      {/* Bandeau titre */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px' }}>
        <div style={{ width: '3px', height: '18px', background: 'linear-gradient(180deg, #04202d, #38bdf8)', borderRadius: '2px', flexShrink: 0 }} />
        <span style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: '20px', fontWeight: '500', letterSpacing: '0.1em', textTransform: 'uppercase', color: '#04202d' }}>
          Réception 
        </span>
      </div>

      {/* Graphique */}
      <div className="graph-container">
        <Graph3 width="750px" height="400px" />
      </div>

      {/* Filtres */}
      <div className="filter-container" style={{ display: 'flex', gap: '10px', marginBottom: '0px' }}>
        <input
          type="text"
          placeholder="Filtrer par Item…"
          value={itemFilter}
          onChange={(e) => setItemFilter(e.target.value)}
        />
        <input
          type="text"
          placeholder="Filtrer par N° de commande…"
          value={numeroCommandeFilter}
          onChange={(e) => setNumeroCommandeFilter(e.target.value)}
        />
        <input
          type="text"
          placeholder="Filtrer par Fournisseur…"
          value={fournisseurFilter}
          onChange={(e) => setFournisseurFilter(e.target.value)}
        />
      </div>

      {/* Bouton reset */}
      <div className="reset-button1-container">
        <button onClick={resetFilters} className="reset-button">
          Réinitialiser les filtres
        </button>
      </div>

      {/* Grand tableau commandes */}
      <div className="table-container3">
        {(() => {
          const sortedData = [...commandeFournisseurData].sort((a, b) =>
            new Date(a['Date de livraison']) - new Date(b['Date de livraison'])
          );
          return renderTable(
            applyCombinedFilter(sortedData),
            Object.keys(sortedData[0] || {}).filter(
              col => col !== 'ID' && col !== 'Client_id' && col !== 'Statut AR'
            )
          );
        })()}
      </div>

      {/* Tableau emplacement vide */}
      <div className="table-container4">
        <h2>Emplacement vide</h2>
        {renderTable(
          emplacementVideData,
          Object.keys(emplacementVideData[0] || {}).filter(
            col => col !== 'ID' && col !== 'Client_id'
          )
        )}
      </div>

      {/* Tableau stock */}
      <div className="table-container5">
        <h2>Stock</h2>
        {renderTable(
          applyFilter(stockData, itemFilter, 'Item'),
          ['Item', 'Nom Dépôt', 'Emplacement', 'Stock']
        )}
      </div>

    </div>
  );
};

export default Reception;